import React from "react";
import { Stack } from "@bookingcom/bui-react";
import { StopsFilterDesktop } from "./FiltersSplit/StopsFilter";
import { AirlinesFilterDesktop } from "./FiltersSplit/AirlinesFilter";
import { FlightTimesFilterDesktop } from "./FiltersSplit/FlightTimesFilter";
import { DurationFilter } from "./FiltersSplit/DurationFilter";
import { BudgetPerAdultFilter } from "./FiltersSplit/BudgetPerAdultFilter";
import { useGetAvailableFilters } from "../SearchResults/components/boundsFilterHooks";
import FlexibilityFilter from "./Filters/FlexibilityFilter";
import {
  AppliedFilterChipsList,
  NewFiltersBaseViewportTracker
} from "../../../components/elements/SearchFilters/components";
import AirportsFilter from "../../../components/elements/SearchFilters/FiltersSplit/AirportsFilter/AirportsFilter";
import flights_web_budget_layover_airports_filters, {
  useTrackNewFilters
} from "../../../utils/experiments/funnel/flights_web_budget_layover_airports_filters";
import styles from "components/elements/SearchFilters/SearchFilters.module.css";
import { WeekendTopFiltersDesktop } from "./FiltersSplit/WeekendTopFilters/WeekendTopFilters.desktop";
import useFlightsWebWeekendTopFilter from "../../../utils/experiments/funnel/flights_web_weekend_top_filter";

const SearchFiltersDesktop = () => {
  const availableFilters = useGetAvailableFilters();

  const { overlap } = useFlightsWebWeekendTopFilter();
  overlap();

  const addNewFilters = !!flights_web_budget_layover_airports_filters.trackWithDefaultStage();
  const isNewFilterAvailable =
    availableFilters.duration?.some((key) => key.durationType === "LAYOVER") ||
    Object.keys(availableFilters).some((key) => ["airports", "budgetPerAdult"].includes(key));
  useTrackNewFilters(isNewFilterAvailable);

  return (
    <div className={addNewFilters ? styles.contentWrapper : undefined} id="search_filters_content_wrapper">
      {Object.keys(availableFilters).length > 0 ? (
        <Stack gap={addNewFilters ? 4 : 8}>
          <WeekendTopFiltersDesktop />
          <StopsFilterDesktop />
          <AirlinesFilterDesktop />
          <FlexibilityFilter />
          <FlightTimesFilterDesktop />
          <DurationFilter />
          <NewFiltersBaseViewportTracker />
          {addNewFilters && (
            <>
              <BudgetPerAdultFilter />
              <AirportsFilter />
              <AppliedFilterChipsList />
            </>
          )}
        </Stack>
      ) : null}
    </div>
  );
};
export default SearchFiltersDesktop;
